// extracted by mini-css-extract-plugin
module.exports = {"text":"RainbowHighlight_text__NcVP4","wrapper":"RainbowHighlight_wrapper__fe2lW","button":"RainbowHighlight_button__bG9Yx"};